export default __webpack_public_path__ + "static/media/cotton1.dc002057.jpg";